import React from 'react';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';

import { OffersBase } from './components/offers-base';

export const OffersPage = React.memo(() => {
  return (
    <>
      <OffersBase />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.OFFER} />
      <FloatingViewCartFab />
    </>
  );
});
